import React, { createContext } from 'react'

const CartContext = createContext([])
const WishlistContext=createContext([])

export default CartContext
